module.exports = __webpack_public_path__ + "img/1-3.833be13e.jpg";